
import {LOAD_REPORT_INFO_ERROR, LOAD_REPORT_INFO_REQUEST, LOAD_REPORT_INFO_SUCCESS} from "./report-info-action-types";

export const loadReportInfoRequest = reportUrl => ({ type: LOAD_REPORT_INFO_REQUEST, reportUrl });
export const loadReportInfoSuccess = reportInfo => ({ type: LOAD_REPORT_INFO_SUCCESS, reportInfo });
export const loadReportInfoError = error => ({ type: LOAD_REPORT_INFO_ERROR, error });



// WEBPACK FOOTER //
// ./src/modules/report-info/report-info-action-creators.js